// Approximate [lat, lon] centroids for the CountryOfBirth values present in
// the parliamentarians data (incl. historical / sub-national names used by
// the Handbook). Used to place "Overseas born" bubbles on a Leaflet map.

const COUNTRY_CENTROIDS = {
  Afghanistan: [33.9, 67.7],
  Australia: [-25.3, 133.8],
  Austria: [47.5, 14.5],
  Belgium: [50.5, 4.5],
  Canada: [56.1, -106.3],
  Ceylon: [7.9, 80.8], // historical Sri Lanka
  Chile: [-35.7, -71.5],
  China: [35.9, 104.2],
  Cyprus: [35.1, 33.4],
  Egypt: [26.8, 30.8],
  England: [52.4, -1.5],
  Fiji: [-17.7, 178.1],
  France: [46.6, 2.2],
  Germany: [51.2, 10.4],
  Greece: [39.1, 21.8],
  Guernsey: [49.5, -2.6],
  'Hong Kong': [22.3, 114.2],
  Hungary: [47.2, 19.5],
  India: [20.6, 79.0],
  Iran: [32.4, 53.7],
  Ireland: [53.4, -8.2],
  Italy: [41.9, 12.6],
  Japan: [36.2, 138.3],
  Kenya: [-0.0, 37.9],
  Malaysia: [4.2, 101.9],
  Malta: [35.9, 14.4],
  Mauritius: [-20.3, 57.6],
  Netherlands: [52.1, 5.3],
  'New Zealand': [-40.9, 174.9],
  Nigeria: [9.1, 8.7],
  'Northern Ireland': [54.7, -6.5],
  Pakistan: [30.4, 69.3],
  'Papua New Guinea': [-6.3, 143.9],
  Poland: [51.9, 19.1],
  Scotland: [56.5, -4.2],
  Singapore: [1.35, 103.8],
  'South Africa': [-30.6, 22.9],
  'Sri Lanka': [7.9, 80.8],
  'The Kingdom of Serbs, Croats and Slovenes': [44.0, 20.9],
  Turkey: [39.0, 35.2],
  'United Kingdom': [54.0, -2.9],
  'United States of America': [39.8, -98.6],
  Vanuatu: [-15.4, 166.9],
  Vietnam: [14.1, 108.3],
  Wales: [52.1, -3.8],
  Yugoslavia: [44.0, 20.9], // historical
  Zimbabwe: [-19.0, 29.2],
};

export default COUNTRY_CENTROIDS;
